<script>
import { reactive, computed, watch, onMounted } from "vue";

import { get } from "@/utils/request";

import MultipleSelect from "@/components/select/multipleSelect.vue";

export default {
  props: {
    modelValue: Array,
    dicData: Array,
    dicUrl: String,
    keyMap: Object,
    multiple: Boolean,
  },
  emits: ["change"],
  setup(props, context) {
    const state = reactive({
      data: [],
    });
    const propMap = computed(() => {
      let map = props.keyMap ? { ...props.keyMap } : {};
      if (!map["label"]) {
        map.label = "label";
      }
      if (!map["value"]) {
        map.value = "value";
      }

      return map;
    });

    watch(
      () => props.dicData,
      (curVal) => {
        state.data = curVal;
      },
      { deep: true }
    );

    //api
    const getList = async () => {
      try {
        const res = await get(props.dicUrl);
        state.data = res.data.data;
      } catch (e) {
        console.log(e);
      }
    };

    //events
    const onChange = (val) => {
      context.emit("update:modelValue", val);
      context.emit("change", val);
    };

    onMounted(() => {
      if (Array.isArray(props.dicData)) {
        state.data = props.dicData;
      } else {
        props.dicUrl && getList();
      }
    });

    return () => (
      <MultipleSelect
        modelValue={props.modelValue}
        list={state.data}
        clearable={true}
        labelKey={propMap.value.label}
        valueKey={propMap.value.value}
        childrenKey={propMap.value.children}
        {...{ "onUpdate:modelValue": onChange }}
      />
    );
  },
};
</script>
